"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentifiedToJSON = exports.IdentifiedFromJSONTyped = exports.IdentifiedFromJSON = void 0;
function IdentifiedFromJSON(json) {
    return IdentifiedFromJSONTyped(json, false);
}
exports.IdentifiedFromJSON = IdentifiedFromJSON;
function IdentifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
exports.IdentifiedFromJSONTyped = IdentifiedFromJSONTyped;
function IdentifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.IdentifiedToJSON = IdentifiedToJSON;
//# sourceMappingURL=Identified.js.map